module.exports = {"211321001":"柳城街道","211321102":"波罗赤镇","211321103":"木头城子镇","211321104":"二十家子镇","211321105":"羊山镇","211321106":"六家子镇","211321107":"瓦房子镇","211321108":"大庙镇","211321110":"古山子镇","211321111":"南双庙镇","211321112":"台子镇","211321113":"清风岭镇","211321114":"胜利镇","211321115":"七道岭镇","211321116":"杨树湾镇","211321211":"西五家子乡","211321212":"北沟门子乡","211321214":"东大道乡","211321215":"乌兰河硕蒙古族乡","211321220":"东大屯乡","211321221":"松岭门蒙古族乡","211321222":"根德营子乡","211321224":"西营子乡","211321228":"北四家子乡","211321230":"王营子乡","211321231":"黑牛营子乡","211321232":"尚志乡","211321400":"国营朝阳县贾家店农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211321.json
// module id = 680
// module chunks = 0